import React from "react";
import MarketingLocationPage from "./MarketingLocationPage";

export default function SocialMediaAgenturKlagenfurt() {
  return <MarketingLocationPage locationKey="klagenfurt" />;
}
